import React from 'react';
import { Arrow } from '../Gestures';

export const HookShotChaperone = ({ target, from, to, key = 0 }) => {
	return {
		gesture: (tr) => (
			<Arrow key={key} target={tr} find={target} from={from} to={to} />
		),
		background: {
			backdropStyle: { opacity: 0.3 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 0.2)' },
			gestureStyle: { zIndex: '999998' },
		},
	};
};
